import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const REVIEW_INVOICE_SCHEMA = Object.freeze({
  INVOICE_ID: '',
  NUMBER: '',
});
const RECORD = generateSchema(REVIEW_INVOICE_SCHEMA);
const KEYS: any = generateKeys(REVIEW_INVOICE_SCHEMA);

export class ReviewInvoice extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get invoiceId(): string {
    return this.get(KEYS.INVOICE_ID);
  }

  get number(): string {
    return this.get(KEYS.NUMBER);
  }
}
